import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import {
  ChevronRight, Calendar, CreditCard, Clock, Landmark, CheckCircle, Rocket, Shield
} from 'lucide-react';

const terms = [
  { icon: Calendar, text: 'ROI income will be generated Monday to Saturday' },
  { icon: CreditCard, text: 'Withdrawal available Monday to Saturday' },
  { icon: 'inr', text: 'Minimum withdrawal ₹200 (multiple of ₹100)' },
  { icon: 'percent', text: 'Withdrawal deduction 10%' },
  { icon: Clock, text: 'Withdrawal time 12:00 AM to 10:00 AM, Bank credit time 2:00 PM' },
  { icon: Landmark, text: 'Deposit and Withdrawal — INR / USDT also accepted' },
  { icon: CheckCircle, text: 'Package valid for 365 days' },
  { icon: Rocket, text: 'Capping ₹1,00,000 per day' },
];

export default function Terms() {
  return (
    <>
      <Navbar />

      {/* PAGE BANNER */}
      <section className="page-banner">
        <div className="page-banner-bg" style={{ backgroundImage: 'url(/mlm2.png)' }} />
        <div className="page-banner-overlay" />
        <div className="container page-banner-content">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="breadcrumb-item">Home</Link>
            <ChevronRight size={14} className="breadcrumb-sep" />
            <span className="breadcrumb-item breadcrumb-current">Terms & Conditions</span>
          </nav>
          <h1 className="page-banner-title">
            TERMS & <span style={{ color: 'var(--primary-light, #6fa0ff)' }}>CONDITIONS</span>
          </h1>
          <p className="page-banner-sub">
            The rules that keep withdrawals, ROI, and your package predictable — please read before you invest.
          </p>
        </div>
      </section>

      {/* TERMS GRID */}
      <section className="section">
        <div className="container">
          <div className="grid-2">
            {terms.map(item => (
              <div key={item.text} className="income-type-card">
                <div className="income-type-icon" style={{ background: 'rgba(var(--primary-rgb),0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {item.icon === 'inr' ? <span style={{ fontSize: '1.2rem', fontWeight: 700 }}>₹</span> : item.icon === 'percent' ? <span style={{ fontSize: '1.2rem', fontWeight: 700 }}>%</span> : <item.icon size={22} />}
                </div>
                <div className="income-type-desc" style={{ fontSize: '0.95rem', color: 'var(--text-light)' }}>{item.text}</div>
              </div>
            ))}
          </div>
          <div className="card" style={{ marginTop: 24, textAlign: 'center', borderColor: 'rgba(var(--primary-rgb),0.5)', background: 'linear-gradient(135deg, rgba(var(--primary-rgb),0.08), rgba(var(--secondary-rgb),0.08))' }}>
            <p style={{ color: 'var(--text-light)', fontWeight: 600, fontSize: '1.05rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, flexWrap: 'wrap' }}>
              <Shield size={20} style={{ color: 'var(--primary)', flexShrink: 0 }} /> Follow <span style={{ color: 'var(--primary)' }}>Rules</span>, Secure Your <span style={{ color: 'var(--primary)' }}>Investment</span>, Grow with <span style={{ color: 'var(--primary)' }}>Confidence</span>.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section section-alt section-relative" style={{ background: 'linear-gradient(135deg, rgba(var(--secondary-rgb),0.1), rgba(var(--primary-rgb),0.08))' }}>
        <div className="glow-orb-field">
          <div className="glow-orb glow-orb-gold" style={{ top: 'auto', bottom: -80, left: '10%' }}></div>
          <div className="glow-orb glow-orb-blue" style={{ top: -60, right: '15%', bottom: 'auto' }}></div>
        </div>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 style={{ fontFamily: 'Rajdhani', fontSize: 'clamp(1.8rem, 4vw, 3rem)', fontWeight: 700, marginBottom: 16 }}>
            READY TO <span style={{ color: 'var(--primary)' }}>JOIN TRIVENI PAY?</span>
          </h2>
          <p style={{ color: 'var(--text-light)', marginBottom: 32, maxWidth: 500, margin: '0 auto 32px' }}>
            Join thousands of investors building their financial future with Triveni Pay. Start with just ₹500 today.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-primary btn-lg">Join Now It's Free</Link>
            <Link to="/login" className="btn btn-outline btn-lg">Login</Link>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}